import { Inject, OnInit } from '@angular/core';
import { ISelectorHeader } from '@platform500services/p500-ui-kit/widgets/applications-selector/applications-selector.interfaces';
import { DestroySubscribers } from '../../../decorators/destroy-subscribers.decorator';
import { BrowserWindowRef } from '../../../services/window/window.service';
import { IEnvironment } from '../../../services/environment/environment.interface';
import { Directive } from '@angular/core';
import { IConfigurationService } from '../../../services/configuration/configuration-service.interface';
import { RbacServiceInterface } from '../../../services/rbac/rbac-service.interface';

@Directive({})
@DestroySubscribers()
// tslint:disable-next-line: directive-class-suffix
export abstract class AppSelectorBaseComponent implements OnInit {
  public header: ISelectorHeader;
  urlControl: string;

  constructor(
    @Inject(BrowserWindowRef) protected window: BrowserWindowRef,
    @Inject('IEnvironmentService') protected envService: IEnvironment,
    @Inject('IConfigurationService') public configurationService: IConfigurationService,
    @Inject('RbacServiceInterface') public rbacService: RbacServiceInterface
  ) {}

  ngOnInit(): void {
    const isProduction = this.envService.getVar('production') as boolean;
    const host = isProduction ? this.window.nativeWindow.location.host : (this.envService.getVar('services.api') as string);
    const hostParsed = host.split('.');
    this.urlControl = `https://control.${hostParsed.length > 1 ? hostParsed[1] : hostParsed[0]}.com`;
    const conf = this.configurationService.data();
    const title = conf.brand.affiliate_crm_name || 'Partner Platform';
    const subtitle = 'Affiliate Area';
    this.header = {
      title,
      subtitle,
    };
  }
}
